(ns machtfit.materialize-widgets
  (:require [machtfit.utils :refer [toggle-in-set]]))

(defn progress-indicator
  "Renders a small spinning wheel indicating something is currently in progress."
  []
  [:div.preloader-wrapper.small.active.left
   {:style {:height "20px" :width "20px" :margin "8px 15px 8px 0"}}
   [:div.spinner-layer.spinner-white-only
    [:div.circle-clipper.left
     [:div.circle]]]])

(defn progress-bar
  "Renders a bar indicating the status of a progress with a known end."
  [current total]
  (let [percent (str (int (* (/ current total) 100)) "%")]
    [:div.progress
     {:style {:height "21px"}}
     [:div.determinate
      {:style {:width percent}}]]))

(defn multi-select [{:keys [values choices on-change]}]
  (let [toggle-choice #(on-change ((fnil toggle-in-set #{}) values %))]
    [:div.row {:style {:display "flex"
                       :flex-wrap "wrap"
                       :margin "10px"}}
     (for [[choice-value choice-label] choices]
       ^{:key choice-value}
       [:span {:style {:width "33%"}}
        [:input.filled-in {:type "checkbox"
                           :id choice-value
                           :checked (some? (some #{choice-value} values))
                           :on-change #(toggle-choice choice-value)}]
        [:label.black-text {:for choice-value} choice-label]])]))
